module.exports = __webpack_public_path__ + "img/20180414165920.34479a37.jpg";